import { array, object, string } from "yup"

export default object({
  name: string().required("Required"),
  categories: array().test({
    message: "Required",
    test: (arr) => arr!.length > 0,
  }),
})
